"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./useQuery"));
__export(require("./useLazyQuery"));
__export(require("./useMutation"));
__export(require("./useSubscription"));
//# sourceMappingURL=index.js.map